var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 18.975L20.9 33L15.125 18.975H5.5L16.225 43.075L12.375 51.75H21.75L36.1 18.975H26.75ZM38 31.825C34.575 31.825 31.975 34.425 31.975 37.5C31.975 40.425 34.475 42.9 37.825 42.9C41.3 42.9 43.9 40.325 43.9 37.25C43.9 34.225 41.4 31.825 38 31.825ZM44.8 8.25L35.225 29.725H45.925L55.5 8.25H44.8Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "homepage/static/media/yahoo.efb324ae720c73eee1e16e6dd9b2160c.svg";
export { ForwardRef as ReactComponent };